import React from 'react';
import './agree.less';
import { Title, Passage0, Passage1, Passage2, Passage3, Passage4, } from '../Agreement/index'
import { Passage5, Passage6, Passage7, Passage8, Passage9, Passage10 } from '../Agreement/index'

// 用户中心>用户协议
const AgreeCom = () => {
    return (
        <div className='agreebody'>
            <Title />
            <Passage0 />
            <Passage1 />
            <Passage2 />
            <Passage3 />
            <Passage4 />
            <Passage5 />
            <Passage6 />
            <Passage7 />
            <Passage8 />
            <Passage9 />
            <Passage10 />
        </div>
    )
}

export default AgreeCom;